import { useTranslation } from 'react-i18next'
import type { MailBoxApi } from './hooks/useMailBox'
import type { MailNavView } from './mailTypes'

/** Klavye kısayolu (/) ile odaklanılan arama kutusu. */
export const MAIL_SEARCH_ID = 'mail-search'

const FOLDER_KEY = { INBOX: 'inbox', SENT: 'sent', DRAFT: 'drafts', SPAM: 'spam', TRASH: 'trash' } as const

/** Seçili klasör / favoriler / grup için başlık. */
export function useViewLabel(box: MailBoxApi) {
  const { t } = useTranslation()
  return (view: MailNavView) => {
    if (view.kind === 'favorites') return t('mail.mailbox.folders.favorites')
    if (view.kind === 'group') return box.groups.find((g) => g.id === view.groupId)?.name ?? ''
    return t(`mail.mailbox.folders.${FOLDER_KEY[view.folder]}`)
  }
}
